'use client';

import { useTranslation } from 'next-i18next/pages';

import { Alert } from '@/components/molecules/Alert';

interface Props {
  status?: number | null;
  setStatus: (status: number | null) => void;
}

export default function WarningMessage({ status, setStatus }: Props) {
  const { t } = useTranslation('login');

  const key = status ?? 500;
  const safeKey = t(`form.errors.${key}.title`) !== `form.errors.${key}.title` ? key : 500;
  const error = `${t(`form.errors.${safeKey}.title`)} ${t(`form.errors.${safeKey}.description`)}`;

  return <Alert message={error} type="error" showIcon onClose={() => setStatus(null)} />;
}
